module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('center', {
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showEmailSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showEmailSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.GENERATING_EMAIL))]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93f6e9e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResendWelcome/ResendWelcome.vue
// module id = 187
// module chunks = 1